export default __webpack_public_path__ + "static/media/solution-front.aa4bb7f5.svg";